/*
 * RP · Anteprima variante al passaggio del mouse sulle miniature colore (PDP)
 * ---------------------------------------------------------------------------
 * - Solo desktop (>= 1000px) con mouse: hover o focus da tastiera su una miniatura
 *   colore -> nome colore sotto le miniature e foto della gallery di quella variante.
 * - Anche le label sopra il titolo (Novità, Promo, label personalizzate) seguono la variante:
 *   l'HTML per ogni variante è pre-renderizzato in <template data-rp-badges-for> (snippets/product-info.liquid).
 * - Uscita dal riquadro miniature -> ripristino della variante selezionata.
 * - Clic -> comportamento invariato (navigazione / selezione del tema).
 * - Le foto sono già nella pagina (nascoste): nessuna richiesta di rete,
 *   la mappa variante -> foto arriva dal JSON stampato in snippets/product-gallery.liquid.
 * - Delega eventi su document: funziona anche dopo il re-render delle sezioni.
 */
(function () {
  'use strict';
  if (window.__rpSwatchPreview) return;
  window.__rpSwatchPreview = true;

  var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1000px)');
  var SWATCH = '.thumbnail-swatch[data-rp-variant]';
  var CONTAINER = '.variant-picker__colors-values, .variant-picker__option-values';

  var state = null; // { container, gallery, items, hiddenBefore, nameEl, nameBefore, minHeightBefore }

  function getRoot(el) {
    return el.closest('product-rerender') || el.closest('.shopify-section') || document;
  }

  function getMap(root) {
    var script = root.querySelector('script[data-rp-variant-media]');
    if (!script) return null;
    if (!script.__rpParsed) {
      try { script.__rpParsed = JSON.parse(script.textContent); } catch (e) { script.__rpParsed = false; }
    }
    return script.__rpParsed || null;
  }

  function start(container) {
    if (state && state.container === container) return state;
    restore();
    var root = getRoot(container);
    var gallery = root.querySelector('product-gallery');
    var items = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__media[data-media-id]')) : [];
    var option = container.closest('.variant-picker__option');
    var nameEl = option ? option.querySelector('.rpm-color-name--below') : null;
    var badgesEl = root.querySelector('[data-rp-badges-current]');
    state = {
      container: container,
      root: root,
      gallery: gallery,
      items: items,
      hiddenBefore: items.map(function (it) { return it.hidden; }),
      nameEl: nameEl,
      nameBefore: nameEl ? nameEl.textContent : null,
      badgesEl: badgesEl,
      badgesBefore: badgesEl ? badgesEl.innerHTML : null,
      minHeightBefore: gallery ? gallery.style.minHeight : '',
      previewing: false
    };
    // Precarica le foto delle altre varianti appena il mouse entra nel riquadro
    items.forEach(function (it) {
      var img = it.querySelector('img[loading="lazy"]');
      if (img) img.loading = 'eager';
    });
    return state;
  }

  function preview(swatch) {
    var container = swatch.closest(CONTAINER);
    if (!container) return;
    var s = start(container);
    var vid = String(swatch.getAttribute('data-rp-variant'));
    var name = swatch.getAttribute('data-rp-name');

    if (s.nameEl && name) s.nameEl.textContent = name;

    if (s.badgesEl) {
      var tpl = s.root.querySelector('template[data-rp-badges-for="' + vid + '"]');
      if (tpl) s.badgesEl.innerHTML = tpl.innerHTML;
    }

    var map = getMap(s.root);
    if (!s.gallery || !map || !map.variants) return;
    var ids = (map.variants[vid] || []).concat(map.common || []).map(String);
    if (!ids.length) return; // variante senza foto assegnate: la gallery resta com'è

    var keep = {};
    ids.forEach(function (id) { keep[id] = true; });
    var visible = s.items.filter(function (it) { return keep[it.getAttribute('data-media-id')]; });
    if (!visible.length) return;

    if (!s.previewing) {
      // blocca l'altezza per evitare salti di layout se la variante ha meno foto
      s.gallery.style.minHeight = s.gallery.offsetHeight + 'px';
      s.previewing = true;
    }
    s.items.forEach(function (it) { it.hidden = !keep[it.getAttribute('data-media-id')]; });
    s.gallery.classList.add('rp-is-previewing');
  }

  function restore() {
    if (!state) return;
    var s = state;
    state = null;
    if (s.nameEl && s.nameBefore !== null) s.nameEl.textContent = s.nameBefore;
    if (s.badgesEl && s.badgesBefore !== null && s.badgesEl.innerHTML !== s.badgesBefore) s.badgesEl.innerHTML = s.badgesBefore;
    if (s.previewing && s.gallery) {
      s.items.forEach(function (it, i) { it.hidden = s.hiddenBefore[i]; });
      s.gallery.style.minHeight = s.minHeightBefore;
      s.gallery.classList.remove('rp-is-previewing');
    }
  }

  function drop() { state = null; } // dopo un clic: il tema aggiorna da solo, non ripristinare

  document.addEventListener('mouseover', function (e) {
    if (!mq.matches) return;
    var sw = e.target.closest && e.target.closest(SWATCH);
    if (sw) preview(sw);
  });

  document.addEventListener('mouseout', function (e) {
    if (!state) return;
    var to = e.relatedTarget;
    if (!to || !state.container.contains(to)) restore();
  });

  document.addEventListener('focusin', function (e) {
    if (!mq.matches) return;
    var t = e.target;
    var sw = t.closest && t.closest(SWATCH);
    // selettore nativo (Readers): il focus va sull'input radio nascosto, la miniatura è la sua label
    if (!sw && t.tagName === 'INPUT' && t.id) {
      var lbl = document.querySelector('label[for="' + t.id + '"]');
      if (lbl && lbl.matches(SWATCH)) sw = lbl;
    }
    if (sw) preview(sw);
  });

  document.addEventListener('focusout', function (e) {
    if (!state) return;
    var to = e.relatedTarget;
    if (!to || !state.container.contains(to)) restore();
  });

  document.addEventListener('click', function (e) {
    if (state && e.target.closest && e.target.closest(SWATCH)) drop();
  }, true);

  // se il tema cambia variante (Readers) o la finestra si restringe, chiudi l'anteprima
  document.addEventListener('variant:change', restore);
  if (mq.addEventListener) mq.addEventListener('change', restore);
})();